import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useMemo, useState } from 'react';
const GrowlerManagerContext = createContext(undefined);
const createGrowlerManagerProvider = () => ({ children }) => {
    const [currentGrowler, setCurrentGrowler] = useState();
    const dismissGrowler = useCallback(() => {
        setCurrentGrowler(undefined);
    }, []);
    const showGrowler = useCallback((growler) => {
        setCurrentGrowler(growler);
    }, []);
    const providerValue = useMemo(() => {
        return {
            currentGrowler,
            dismissGrowler,
            showGrowler,
        };
    }, [currentGrowler, dismissGrowler, showGrowler]);
    return (_jsx(GrowlerManagerContext.Provider, { value: providerValue, children: children }));
};
export { createGrowlerManagerProvider, GrowlerManagerContext };
if (process.env.NODE_ENV !== 'production') {
    GrowlerManagerContext.displayName = 'GrowlerManagerContext';
}
//# sourceMappingURL=GrowlerManagerProvider.js.map